import { BreadCrumb } from "primereact/breadcrumb";
import { useParams } from "react-router-dom";
import MeaPage from "../../components/MeaPage";
import MeaLink from "../../components/MeaLink";
import { useAuthContext } from "../../hooks/useAuthContext";
import SchoolMailsListComponent from "./components/SchoolMailsListComponent";

const SchoolMailsPage = () => {
  const { currentMembership } = useAuthContext();
  const params = useParams();
  const schoolId = params.schoolId || currentMembership?.school?.id;

  const breadcrumb = [
    {
      template: () => (
        <MeaLink to={`/school/${schoolId}/admin`} icon="pi pi-home" isRipple={true}>
          {currentMembership?.school?.name || "Accueil"}
        </MeaLink>
      ),
    },
    { label: "Emails" },
  ];

  return (
    <MeaPage
      title="Emails"
      subtitle="Liste des derniers emails envoyés"
      breadcrumb={<BreadCrumb model={breadcrumb} />}
      showBackButton={true}
    >
      <SchoolMailsListComponent schoolId={schoolId} />
    </MeaPage>
  );
};

export default SchoolMailsPage;
